import * as React from "react"
import {isEmpty as _isEmpty} from "lodash";
import * as $ from "jquery"
import {connect} from "react-redux"
import {default as AppUtils, LOADING_STATE} from "../utils/AppUtils"
import DoctorProfile from "../models/IDoctorProfile"
import AccountData from "../models/IAccountData"
import {AccountDataActions} from "../actions/AccountDataActions"
import {DoctorProfileActions} from "../actions/DoctorProfileActions"
import {IAppState} from "../models/IAppState"
import DoctorProfileCard from "../components/doctorProfile/DoctorProfileCard";
import ISearchDoctor from "../models/ISearchDoctor";
import {Tracker} from "../utils/Tracker";

export interface DoctorProfilePageProps {
    accountData: AccountData;
    doctorProfile: DoctorProfile;
    saveDoctorProfile: (doctorProfile: DoctorProfile) => Promise<DoctorProfile[]>;
    fetchDoctorProfile: (searchParams: ISearchDoctor) => Promise<DoctorProfile>;
    fetchAccountData: () => Promise<AccountData>;
}

export interface DoctorProfilePageState {
    doctorProfileLoadingState: LOADING_STATE;
    doctorProfileCopy: DoctorProfile;           // This will be passed to the modals, so that unless save is pressed, the original object won't change.
    showAccountDetailsFormModal: boolean;
}

class DoctorProfilePage extends React.Component<DoctorProfilePageProps, DoctorProfilePageState> {

    constructor (props: DoctorProfilePageProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps(props: DoctorProfilePageProps) {
        let doctorProfileLoadingState = LOADING_STATE.NOT_INITIALIZED
        let doctorProfileCopy: DoctorProfile = null;
        if (!_isEmpty(props.accountData)) {
            // if (AppUtils.isDoctor(props.accountData)) {
                if (_isEmpty(props.doctorProfile)) {
                    const searchParams: ISearchDoctor = {
                        emailId: [AppUtils.getDoctorEmail(props.accountData)]
                    };
                    props.fetchDoctorProfile(searchParams);
                    doctorProfileLoadingState = LOADING_STATE.LOADING
                } else {
                    doctorProfileCopy = $.extend(true, {}, props.doctorProfile);
                    doctorProfileLoadingState = LOADING_STATE.LOADED
                }
            // }
        } else {
            this.props.fetchAccountData()
        }
        return {
            doctorProfileLoadingState: doctorProfileLoadingState,
            doctorProfileCopy: doctorProfileCopy,
            showAccountDetailsFormModal: false,
        }
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState(this.getStateFromProps(nextProps));
    }

    componentDidMount(): void {
        Tracker.pageOpened("Profile");
    }

    componentWillUnmount(): void {
        Tracker.pageClosed("Profile")
    }

    render() {
        return (
            this.props.doctorProfile &&
            <div className="doctor-profile">
                <DoctorProfileCard doctorProfile={this.props.doctorProfile} />
            </div>

        )
    }
}

function mapStateToProps(state: IAppState): any {
    return Object.assign({}, {
        accountData: state.accountData,
        doctorProfile: state.doctorProfile
    })
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        saveDoctorProfile: (doctorProfile: DoctorProfile) => {
            return DoctorProfileActions.updateDoctorProfile(dispatch, doctorProfile)
        },
        fetchDoctorProfile: (searchParams: ISearchDoctor) => {
            return DoctorProfileActions.fetchDoctorProfile(dispatch, searchParams);
        },
        fetchAccountData: () => {
            return AccountDataActions.fetchAccountData(dispatch);
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DoctorProfilePage)
